import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import cell from '../../assets/img/cell.png'
import { Slider } from '../../components/Slider'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Header from '../Header'
import ServicesSection from '../../components/ServicesSection'
import Advantages from '../../components/Advantages'
import left from '../../assets/img/icon/left.png'
import right from '../../assets/img/icon/right.png'
import FAQSection from '../../components/sections/QASection'
import rightArrow from '../../assets/img/icon/right.png'
import { useNavigate } from 'react-router-dom'
import vector from '../../assets/img/icon/Vector.png'
import pointer from '../../assets/img/landing/1.png'
import p2 from '../../assets/img/landing/2.png'
import p3 from '../../assets/img/landing/3.png'
import p4 from '../../assets/img/landing/4.png'
import p5 from '../../assets/img/landing/5.png'
import down from '../../assets/img/icon/arrow_down.png'
import blue_down from '../../assets/img/icon/blue_arrow.png'
import signin from '../../assets/img/icon/time.png'
import cellVideo from '../../assets/video/cell.mp4'
import BottomSection from '../../components/BottomSection'
import CustomerSatisfactionSection from '../../components/sections/CustomerSatisfication'
import sten from '../../assets/img/news/genetic_service.png'
import news2 from '../../assets/img/news/news.png'
import open from '../../assets/img/news/open_new.jpg'
import uudel_es from '../../assets/img/news/uudel_es.png'

const data4 = [
  {
    id: 1,
    date: '2025/01/10',
    title:
      'Монгол Улсад анх удаа үүдэл эс хадгалах болон эсийн эмчилгээний бүтээгдэхүүн үйлдвэрлэх хамгийн орчин үеийн дэвшилтэт технологийг нэвтрүүлсэн Селл Клиник эмнэлэг албан ёсоор үйл ажиллагаагаа эхлүүллээ.',
    description:
      'Манай эмнэлэг нь олон улсын GMP лабораторийн стандарт-ын дагуу эс боловсруулах, хадгалах, эсийн эмчилгээний үйлчилгээг санал болгож байна.',
    category: 'Мэдээ',
    color: '#81C4E9',
    img: open
  },
  {
    id: 2,
    date: '2025/02/05',
    title: 'Эсийн банк гэж юу вэ? ...яагаад чухал вэ?',
    description:
      'Эсийн банк гэдэг нь ирээдүйд эмчилгээ, судалгаанд ашиглах зорилгоор эсийг цуглуулан, боловсруулж хадгалдаг эрүүл мэндийн байгууллагыг хэлнэ. Энэ нь эрүүл мэндийн салбар болон биотехнологийн салбарт найдвартай, тогтвортой эсийн нөөцийг бүрдүүлэх чухал ач холбогдолтой.',
    category: 'Блог',
    img: news2
    // color: '#81C4E9'
  },
  {
    id: 3,
    date: '2025/02/11',
    title: 'Үүдэл эсийн ангилал',
    description:
      'Үүдэл эсүүд нь өөрийгөө олшруулах чадвартай, ялгаран хөгжөөгүй эсүүд бөгөөд олон төрлийн эс болж ялгаран хөгжих чадвартай.',
    category: 'Блог',
    color: '#81C4E9',
    img: sten
  },
  {
    id: 4,
    date: '2025/02/16',
    title: 'Үүдэл эсийн судалгааны түүх',
    //  color: '#81C4E9',
    description:
      'Үүдэл эсийн судалгаа нь анагаах ухаан, Био Анагаах ялангуяа эсийн биологи, нөхөн төлжүүлэх анагаах ухааны хамгийн чухал ололтуудын нэг билээ.',
    category: 'Блог',
    img: uudel_es
  }
]

export default function LandingPage () {
  const [sliderState, setSliderState] = useState(0)
  const navigate = useNavigate()
  const [showMessage, setShowMessage] = useState(false)
  const introSectionRef = useRef(null)
  const servicesSectionRef = useRef(null)
  const advantageSessionRef = useRef(null)
  const faqSectionRef = useRef(null)
  const footerSectionRef = useRef(null)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50) // Adjust threshold as needed
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  // Scroll handler
  const scrollToSection = sectionRef => {
    if (sectionRef?.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const handlePrevClick = () => {
    setSliderState(prev => {
      const newIndex = prev === 0 ? data4.length - 1 : prev - 1
      return newIndex
    })
  }

  const handleNextClick = () => {
    setSliderState(prev => {
      const newIndex = prev === data4.length - 1 ? 0 : prev + 1
      return newIndex
    })
  }

  const callNewsDetail = () => {
    navigate('/news/1')
    window.scrollTo(0, 0)
  }

  const items = data4.map((item, index) => (
    <React.Fragment key={item.id}>
      <div className='flex flex-row h-[30vh] mobile:flex-col mobile:h-[65vh] medee-short'>
        <div
          className={`bg-[#93D293] rounded-l-[16px] rounded-r-none w-full flex flex-row items-center justify-center mobile:rounded-l-none mobile:h-[30vh]`}
          style={{
            backgroundColor: item.color ? item.color : '#93D293'
          }}
        >
          <div className='p-[2rem]'>
            <p className='text-white/55 ml-[0.88rem]  text-[16px]'>
              {index + 1} / {data4.length}
            </p>
            <p className='ml-[0.88rem] w-[620px] mt-10 font-sfpro text-[1.25rem] mobile:w-full mobile:text-[14px] font-black uppercase tracking-[0.00rem] text-white md:text-[1.13rem] sm:m mb-2'>
              {item.title}
            </p>
            <p className='ml-[0.88rem] text-white mb-10'>{item.desc}</p>
            <button className='border border-white text-white rounded-[16px] w-[70px] text-[12px] py-[5px] ml-[0.88rem]'>
              {item.category}
            </button>
          </div>
          <div
            className='h-[120px] w-[60px] justify-center relative flex-shrink-0
            text-green border border-solid border-[#CED2E8] border-r-0 overflow-hidden rounded-full rounded-r-none mobile:hidden'
            onClick={callNewsDetail}
          >
            <img
              src={rightArrow}
              alt='rArrow'
              className='absolute top-[35%] left-5 z-20 h-[30%] object-cover'
            />
          </div>
        </div>
        <div className='w-full mobile:h-[30vh] '>
          <img
            src={item.img}
            alt='researcher'
            className='rounded-r-[16px] rounded-l-none object-cover w-full h-full mobile:rounded-r-none'
          />
        </div>
      </div>
    </React.Fragment>
  ))

  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta
          name='description'
          content='Монгол Улсын анхны хүний эсийн банк болон олон улсын стандартад нийцсэн анхны GMP лаборатори бүхий манай эмнэлэг нь эсийн хадгалалт, боловсруулах, эмчилгээ, генетик шинжилгээний тэргүүлэх технологийг нэвтрүүлж байна.
            '
        />
        <meta property='og:title' content='CellClinic - Banking and Therapy' />
        <meta
          property='og:description'
          content='Монгол Улсын анхны хүний эсийн банк болон олон улсын стандартад нийцсэн анхны GMP лаборатори бүхий манай эмнэлэг нь эсийн хадгалалт, боловсруулах, эмчилгээ, генетик шинжилгээний тэргүүлэх технологийг нэвтрүүлж байна.'
        />
        <meta
          property='og:image'
          content='https://cellclinic.mn/static/media/aboutus_bg.15743d23913f573221aa.jpg'
        />
        <meta property='og:url' content='https://cellclinic.mn' />
        <meta property='og:type' content='website' />
      </Helmet>
      <div
        className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full max-w-[1440px] extraScreen:max-w-[1640px] z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-blue shadow-md h-[7vh] top-2'
            : // extraScreen:max-w-[1500px] maxScreen:max-w-[1280px] max-w-[1004px]
              'bg-transparent h-[5vh]'
        }`}
      >
        <Header
          color={isScrolled ? 'black' : 'white'}
          gradientColor={isScrolled ? 'bg-white/90' : 'bg-none'}
        />
      </div>

      <div className='flex flex-col bg-gradient-to-l from-[#89D4E5] to-[#08273C] w-full h-[100vh] short-screen '>
        {/* Main Content */}
        <div className='max-h-[90vh] short-screen temp:max-h-[100vh] flex-grow maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mobile:mt-[-80px]'>
          <div className='h-[80vh] temp:h-[100vh] short-screen flex flex-row items-center justify-between mobile:flex-col px-20 maxScreen:px-0 extraScreen:px-0 gap-5 mobile:gap-0 mobile:p-5 tablet:flex-col tablet:px-5'>
            {/* Left Section */}
            <div className='mx-auto extraScreen:w-[720px] maxScreen:w-[650px] mobile:w-full flex flex-col mobile:justify-center mobile:items-center tablet:w-full tablet:h-1/2 tablet:justify-center tablet:items-center'>
              <p
                className='text-[57px] mobile:text-[24px] text-white font-inter font-extrabold mobile:text-center mobile:mt-[210px] tablet:text-[36px] tablet:w-[437px]  tablet:text-center'
                style={{ lineHeight: 1.4 }}
              >
                ЭСИЙГ ХАДГАЛНА
                <br />
                ЭСЭЭР ЭМЧИЛНЭ
              </p>
              <p className='text-[18px] mt-4 w-[540px] text-left text-white/70 mobile:text-center mobile:mt-10 mobile:w-[360px] mobile:ml-0 mobile:text-[12px] tablet:text-[18px] tablet:text-center temp:w-[500px]'>
                Монгол Улсын анхны үүдэл эсийн банк болон эсийн эмчилгээний олон
                улсын стандартад нийцсэн GMP лаборатори бүхий манай эмнэлэг нь
                эсийн хадгалалт, боловсруулалт, эмчилгээ, генетик шинжилгээний
                тэргүүлэх технологийг нэвтрүүлж байна.
              </p>

              <div className='mobile:mt-6'>
                <button
                  className='flex h-10 min-w-[60px] w-[160px] text-[14px] px-0 justify-center items-center gap-0 rounded-lg border border-[rgba(255,255,255,0.16)] bg-[rgba(255,255,255,0.16)] text-white mt-5'
                  onMouseEnter={() => setShowMessage(true)}
                  onMouseLeave={() => setShowMessage(false)}
                >
                  <img
                    src={signin}
                    alt='Arrow Down'
                    className='h-4 w-4'
                    style={{ marginRight: 10 }}
                  />
                  Цаг захиалах
                </button>

                {showMessage && (
                  <p className='bg-[rgba(255,255,255,0.16)] w-[180px] text-[12px] text-white text-center ml-[180px] rounded-lg mt-5 absolute z-1 p-5 mobile:ml-2'>
                    Та цаг захиалах бол 77760000 дугаарт залгана уу.
                  </p>
                )}
              </div>
            </div>

            {/* Right Section */}
            <div className='w-1/2 extraScreen:w-[720px] mobile:w-full tablet:w-full tablet:h-1/2 maxScreen:max-w-[720px] tablet:items-center tablet:justify-center tablet:flex mobile:mt-[0px]'>
              <div className='relative flex self-center bg-cover bg-center h-fit w-fit'>
                <img
                  src={cell}
                  alt='Cede'
                  className='w-[600px] h-[600px] tablet:w-[600px] tablet:h-[600px] mobile:h-full mobile:w-full temp:w-[500px] temp:h-[500px] extraScreen:w-full extraScreen:h-full'
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='h-[16vh] flex-shrink-0 mobile:hidden temp:hidden desktop:px-0 mobile:px-0 tablet:px-0 extraScreen:px-0 maxScreen:px-0 hid'>
          <BottomSection
            pointer={pointer}
            down={down}
            scrollToSection={scrollToSection}
            nextRef={servicesSectionRef}
            d='M0,50 C300,450 900,-100 1100,160'
            width='100%'
            left={13}
          />
        </div>
      </div>

      {/* Section 2 */}
      <div
        ref={servicesSectionRef}
        className='h-[100vh] temp:h-[70vh] short-screen flex flex-col justify-center relative overflow-hidden mobile:h-full tablet:h-full bg-gradient-to-r from-[#08273D] to-[#89D4E5] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]'
      >
        <div className='max-h-[90vh] temp:h-[80vh] short-screen mobile:max-h-full tablet:max-h-full maxScreen:max-h-[90vh] extraScreen:max-h-[80vh] mb-[40px]'>
          <ServicesSection></ServicesSection>
        </div>
        <div
          className='h-[10vh] flex-shrink-0 mobile:hidden temp:hidden hid'
          //  className='h-[20vh] mt-[-4vh] mobile:hidden'
        >
          <BottomSection
            pointer={p2}
            down={down}
            scrollToSection={scrollToSection}
            nextRef={advantageSessionRef}
            d='M0,50 C300,450 900,-100 1100,160'
            width='80%'
            left={50}
          />
        </div>
      </div>
      <div
        className='relative h-[100vh] short-screen overflow-hidden mobile:h-full tablet:h-full mobile:bg-gradient-to-l from-[#89D4E5] to-[#e6eef4] '
        ref={advantageSessionRef}
      >
        <video
          id='video'
          autoPlay
          muted
          loop
          src={cellVideo}
          className='absolute top-0 left-0 w-full h-full object-cover z-[-1] transition-transform duration-300 ease-in-out mobile:hidden'
          onMouseEnter={() => {
            document.getElementById('video').style.transform = 'scale(1.05)'
          }}
          onMouseLeave={() => {
            document.getElementById('video').style.transform = 'scale(1)'
          }}
        ></video>
        <div className={`h-[90vh]  mobile:h-[100vh] short-screen `}>
          <Advantages></Advantages>
        </div>
        {/* Bottom Section */}
        <div className='h-[10vh] mobile:hidden temp:hidden tablet:hidden hid'>
          {/* <div className='h-[10vh] mt-[-12vh] mobile:hidden'> */}
          <BottomSection
            pointer={p3}
            down={blue_down}
            scrollToSection={scrollToSection}
            nextRef={introSectionRef}
            d='M0,50 C300,450 900,-100 1100,160'
            width='60%'
            left={90}
            strokeColor='#215998'
          />
        </div>
      </div>
      {/* Section 2 */}
      <div
        className=' bg-[rgb(220,238,242)]  h-[100vh] mobile:h-full tablet:h-[80vh] short-screen'
        ref={introSectionRef}
      >
        <div className='h-[90vh] mobile:h-full tablet:h-[60vh] short-screen'>
          <section
            id='about'
            className='relative overflow-hidden  p-20 
                   mobile:py-5 mobile:px-5 mobile:p-5 mobile:flex mobile:flex-col mobile:justify-between mobile:h-full
             tablet:py-5 tablet:px-5 tablet:p-5 
             maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
          >
            <div className='flex flex-row justify-between h-[40px] '>
              <div className='flex flex-row items-center text-[#215998] mobile:text-[10px] '>
                <p className=''>04 / 06</p>
                <p className='ml-8 text-[#398292] gap-2 '>|</p>
                <p className='ml-8 uppercase text-[36px] font-bold mobile:text-[16px] text-[#398292] tablet:text-[28px] tablet:text-[#215998]'>
                  мэдээ мэдээлэл
                </p>
                <div className='flex flex-row items-center'>
                  {/* <p className='ml-8 text-[14px] text-[#398292] tablet:hidden mobile:hidden'>
                    Бүгдийг үзэх
                  </p> */}
                  <img
                    src={vector}
                    alt='vec'
                    className='ml-[20px] tablet:hidden mobile:hidden'
                  />
                </div>
              </div>
              <div className='flex flex-row h-[48px] justify-center items-center mobile:h-[40px]'>
                <div
                  className='border border-[#215998] p-2 rounded-l-[8px] rounded-r-none cursor-pointer'
                  onClick={handlePrevClick}
                >
                  <img
                    src={left}
                    alt='Caret Left'
                    className='mobile:h-2 mobile:w-2'
                  />
                </div>
                <div
                  className='border border-[#215998] p-2 rounded-r-[8px] rounded-l-none border-l-0 cursor-pointer'
                  onClick={handleNextClick}
                >
                  <img
                    src={right}
                    alt='Caret Right'
                    className='mobile:h-2 mobile:w-2'
                  />
                </div>
              </div>
            </div>
            <div className='relative  h-[100%] mt-5 mobile:mt-5 tablet:mt-10 mb-2 mobile:h-[65vh] '>
              {/* <div className='overflow-hidden h-[100%] mt-[10vh] mobile:mt-5 tablet:mt-10'> */}
              <Slider
                items={items}
                autoplay
                autoplaySpeed={60000}
                dots={false}
                responsive={{
                  0: { items: 1 },
                  551: { items: 1 },
                  1051: { items: 1 }
                }}
                infinite
                activeIndex={sliderState}
                afterChange={current => {
                  setSliderState(current)
                }}
              />
            </div>
            <div className='mobile:mt-5 h-[60vh] mt-20 mobile:h-[70vh] medee-short '>
              <CustomerSatisfactionSection></CustomerSatisfactionSection>
            </div>
          </section>
        </div>
        {/* Bottom Section */}
        <div className='h-[20vh] mobile:hidden tablet:hidden temp:hidden hid'>
          <BottomSection
            pointer={p4}
            down={blue_down}
            scrollToSection={scrollToSection}
            nextRef={faqSectionRef}
            d='M0,50 C300,450 900,-100 1100,160'
            width='40%'
            left={133}
            strokeColor='#215998'
          />
        </div>
      </div>
      <div className='h-[100vh] f-screen relative overflow-hidden mobile:h-[90vh] tablet:h-[80vh] mobile:mt-0 mobile:mb-4  flex flex-col justify-center tablet:mb-20'>
        <div
          className='max-h-[85vh] w-full short-screen mobile:max-h-[100vh] tablet:max-h-[90vh] px-20 mobile:py-0 mobile:mt-[-40px] mobile:px-5 tablet:py-0 tablet:px-5 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mb-10'
          ref={faqSectionRef}
        >
          <div className='py-10 mobile:py-0 tablet:py-10 overflow-hidden'>
            <FAQSection></FAQSection>
          </div>
        </div>
        {/* Bottom Section */}
        <div className='h-[10vh] mobile:hidden tablet:hidden temp:hidden hid'>
          <BottomSection
            pointer={p5}
            down={blue_down}
            scrollToSection={scrollToSection}
            nextRef={footerSectionRef}
            width='40%'
            left={170}
            strokeColor='#215998'
          />
        </div>
      </div>
      {/* contact us section */}
      <div
        className='px-20 mt-0 mobile:mt-0 mobile:mb-10 mobile:p-5 tablet:p-5  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
        ref={footerSectionRef}
      >
        <ConnectUs bgImage='blue'></ConnectUs>
        <div className='mt-5'></div>
        <FooterSection></FooterSection>
      </div>
    </>
  )
}
